import { getLocalStorageValue, setLocalStorageValue } from './store/localstorage'

export const MIN_TABLE_WIDTH = 480
// Default split(x) pane width: table content (scroll.x) + pane borders + a
// conservative vertical-scrollbar allowance, so the table shows no horizontal
// scrollbar at the default splitter position (with or without a vertical scrollbar).
export const MIN_PANE_WIDTH = 500
export const ROW_LAYOUT_MIN_WIDTH = 1100
export const SPLIT_MIN = 0.2
export const SPLIT_MAX = 0.8
export const SPLIT_STORAGE_KEY = 'trainer/activitiesSplit'

export function clampSize(size, panesSize, min = SPLIT_MIN, max = SPLIT_MAX) {
    if (panesSize <= 0) return size
    return Math.max(min * panesSize, Math.min(max * panesSize, size))
}

export function defaultSplitSize(axis, panesSize) {
    if (panesSize <= 0) return panesSize
    return axis === 'x' ? MIN_PANE_WIDTH : 0.5 * panesSize
}

export function loadSplit() {
    try {
        const value = getLocalStorageValue(SPLIT_STORAGE_KEY, null)
        if (!value || typeof value !== 'object') return null
        const { x, y } = value
        if (Number.isFinite(x) && Number.isFinite(y)) return { x, y }
        return null
    } catch (e) {
        return null
    }
}

export function saveSplit(split) {
    try {
        setLocalStorageValue(SPLIT_STORAGE_KEY, { x: split.x, y: split.y })
    } catch (e) {
        // localStorage unavailable (private mode / blocked) — ignore.
    }
}

export function formatActivityDate(ts) {
    const d = new Date(ts * 1000)
    const pad = (n) => (n < 10 ? '0' + n : String(n))
    return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${String(d.getFullYear()).slice(-2)} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}
